const safariDate = (dt) => {
  if (typeof dt !== 'string') {
    return dt;
  }
  let parts = String(dt).split(' ');
  let first = parts.shift().replace(/-/g, '/');
  return [first, ...parts].join(' ');
};

export default safariDate;
